import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'
import {useEffect} from 'react'

import {getRepoIssuesSidebarPanes} from '../components/sidebar/get-repo-issues-sidebar-panes'
import {
  IssueIndexPage,
  IssueShowPage,
  RepositoryLabelIndexPage,
  RepositoryMilestoneIndexPage,
  RepositoryMilestonePage,
} from '../lazy-routes'
import {preloadWhenIdle} from '../utils/preload-when-idle'

export function IssueViewsPage() {
  useEffect(() => {
    return preloadWhenIdle(() => {
      IssueIndexPage.preload()
      IssueShowPage.preload()
      RepositoryMilestoneIndexPage.preload()
      RepositoryLabelIndexPage.preload()
      RepositoryMilestonePage.preload()
    })
  }, [])

  const sidebarPanes = getRepoIssuesSidebarPanes()

  if (!isFeatureEnabled('issue_pinned_views') || !isFeatureEnabled('issue_pinned_views_index_page')) {
    return null
  }

  return (
    <ThreePanesLayout
      contentAs="div"
      resizeable={false}
      leftPaneWidth="medium"
      leftPane={sidebarPanes.leftPane}
      collapsibleLeftPane={sidebarPanes.collapsibleLeftPane}
      middlePane={<p>Views page</p>}
    />
  )
}
